import themes from '../config/themes.json'

const trimCode = str => str.replace(/\n {2}\n/g, '\n').replace(/\n {2}\n/g, '\n').replace(/\n\n\n/g, '\n\n')

export default (profile, rootClass = '.body', options = {}) => {
  const fixedProfile = Object.assign({}, themes[0].profile, profile)
  const headerColor = fixedProfile.headerColor || fixedProfile.textColor
  const sourceInfo = '/* ----- Generated by https://tomsoderlund.github.io/design-profile-generator/ ----- */'
  return trimCode(`${sourceInfo}

${rootClass} {
  background-color: ${fixedProfile.backgroundColor};
  color: ${fixedProfile.textColor};
  font-family: '${fixedProfile.textFont}', sans-serif;
  font-size: ${fixedProfile.textSize};
  font-weight: ${fixedProfile.textWeight};
}

h1, h2, h3 {
  line-height: 1.1em;
  ${fixedProfile.headlineColor ? `color: ${fixedProfile.headlineColor};` : ''}
  ${fixedProfile.headlineFont ? `font-family: '${fixedProfile.headlineFont}', sans-serif;` : ''}
  ${fixedProfile.headlineWeight ? `font-weight: ${fixedProfile.headlineWeight};` : ''}
  ${fixedProfile.headlineItalic ? 'font-style: italic;' : ''}
  ${fixedProfile.headlineUppercase ? 'text-transform: uppercase;' : ''}
}

nav {
  background-color: ${headerColor};
  color: ${fixedProfile.backgroundColor};
  ${fixedProfile.headlineFont ? `font-family: '${fixedProfile.headlineFont}', sans-serif;` : ''}
  ${fixedProfile.headlineWeight ? `font-weight: ${fixedProfile.headlineWeight};` : ''}
  ${fixedProfile.headlineItalic ? 'font-style: italic;' : ''}
  ${fixedProfile.headlineUppercase ? 'text-transform: uppercase;' : ''}
  padding: 0.8em;
  text-align: center;
}

main {
  padding: 0.4em 1em;
}

a {
  color: ${fixedProfile.actionColor};
  transition: all 0.2s;
}
a:hover {
  opacity: 0.6;
}
a:active {
  opacity: 1;
}

/* #NiceAndSimple: Button - http://codepen.io/tomsoderlund/pen/qqyzqp */
button {
  background-color: ${headerColor};
  color: ${fixedProfile.backgroundColor};
  position: relative;
  border-radius: 0.2em;
  border: none;
  box-sizing: border-box;
  display: inline-block;
  cursor: pointer;
  user-select: none;
  font-family: inherit;
  font-size: inherit;
  line-height: normal;
  ${fixedProfile.headlineFont ? `font-family: '${fixedProfile.headlineFont}', sans-serif;` : ''}
  ${fixedProfile.headlineWeight ? `font-weight: ${fixedProfile.headlineWeight};` : ''}
  ${fixedProfile.headlineItalic ? 'font-style: italic;' : ''}
  ${fixedProfile.headlineUppercase ? 'text-transform: uppercase;' : ''}
  text-align: center;
  outline: none;
  padding: 0.6em;
  margin-right: 0.6em;
  transition: all 0.2s;
  min-width: 7em;
}
button:focus:not(:disabled) {
  opacity: 0.8;
}
button:hover:not(:disabled) {
  opacity: 0.8;
  top: -0.1em;
}
button:hover:active {
  top: 0.1em;
  transition: all 0.05s;
}
button:disabled {
  cursor: initial;
  background-color: silver;
}

button.primary {
  background-color: ${fixedProfile.actionColor};
}

/* #NiceAndSimple: Input and Dropdown Menu - http://codepen.io/tomsoderlund/pen/GNBbWz */
input${options.preview ? ':not([type=\'color\'])' : ''},
textarea,
select {
  background-color: white;
  color: inherit;
  outline: none;
  resize: none;
  box-sizing: border-box;
  border-radius: 0.2em;
  border: 1px solid lightgray;
  font-family: inherit;
  font-size: inherit;
  font-weight: inherit;
  padding: 0.6em;
  margin-right: 0.6em;
  transition: all 0.2s;
  min-width: 15em;
}
input::placeholder,
textarea::placeholder {
  color: lightgray;
}
input:hover:not(:disabled):not(:focus),
.input-like:hover:not(:disabled):not(:focus),
textarea:hover:not(:disabled):not(:focus),
select:hover:not(:disabled):not(:focus) {
  border-color: silver;
}
input:focus,
.input-like:focus,
textarea:focus,
select:focus {
  border-color: darkgray;
}
input:read-only,
textarea:read-only {
  color: darkgray;
}
input:disabled,
.input-like:disabled,
textarea:disabled,
select:disabled {
  background-color: whitesmoke;
}

${fixedProfile.backgroundColor ? `.color-background-bg { background-color: ${fixedProfile.backgroundColor}; }\n.color-background-fg { color: ${fixedProfile.backgroundColor}; }` : ''}
${fixedProfile.textColor ? `.color-text-bg { background-color: ${fixedProfile.textColor}; }\n.color-text-fg { color: ${fixedProfile.textColor}; }` : ''}
${fixedProfile.headlineColor ? `.color-headline-bg { background-color: ${fixedProfile.headlineColor}; }\n.color-headline-fg { color: ${fixedProfile.headlineColor}; }` : ''}
${fixedProfile.actionColor ? `.color-action-primary-bg { background-color: ${fixedProfile.actionColor}; }\n.color-action-primary-fg { color: ${fixedProfile.actionColor}; }` : ''}
${headerColor ? `.color-action-secondary-bg { background-color: ${headerColor}; }\n.color-action-secondary-fg { color: ${headerColor}; }` : ''}
${headerColor ? `.color-header-bg { background-color: ${headerColor}; }` : ''}
${fixedProfile.warningColor ? `.color-warning-bg { background-color: ${fixedProfile.warningColor}; }\n.color-warning-fg { color: ${fixedProfile.warningColor}; }` : ''}
${fixedProfile.informationColor ? `.color-information-bg { background-color: ${fixedProfile.informationColor}; }\n.color-information-fg { color: ${fixedProfile.informationColor}; }` : ''}

${sourceInfo}`)
}
